import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class MailConfigService {
    getConfig(id) {
        return axios.get(API_URL+'config/mail/'+id, { headers: authHeader() });
    }
    check(data) {
        return axios.post(API_URL+'config/mail/check',data, { headers: authHeader() });
    }
   
}

export default new MailConfigService();
